module.exports = __webpack_public_path__ + "static/media/valuation_hero_house_2.e743cf80.svg";